/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as echarts from 'echarts';

// Component imports
import EchartsWrapper from './EchartsWrapper';
import { formatNumberToThousandSeparator } from '../../utils/string/formatNumberToThousandSeparator';

const DashboardTotalSessionsSection = ({ data = [], loading = false }) => {
  const { t } = useTranslation();

  const getOptions = (chartData) => {
    const xData = chartData.map(item => item.x);
    const yData = chartData.map(item => item.y);

    return {
      color: ['#5FAAFF'],
      grid: {
        left: '0%',
        right: '0%',
        bottom: '100%',
        top: '98%'
      },
      legend: {
        show: false
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          show: true,
          type: 'none'
        },
        triggerOn: 'mousemove|click',
        enterable: true,
        renderMode: 'html',
        confine: true,
        formatter: (params) => {
          const { name, value, marker } = params[0];
          return `${name}<br />${marker} ${t('Sessions')} : ${formatNumberToThousandSeparator(value)}`;
        }
      },
      xAxis: [{
        show: false,
        type: 'category',
        position: 'bottom',
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        data: xData
      }],
      yAxis: [
        {
          type: 'value',
          show: false
        }
      ],
      series: [
        {
          smooth: true,
          name: t('Sessions'),
          type: 'line',
          showSymbol: false,
          data: yData,
          areaStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#5FAAFF'
              },
              {
                offset: 1,
                color: '#ffffff'
              }
            ])
          }
        }
      ]
    };
  };

  return (
    <EchartsWrapper
      chartOptions={getOptions(data)}
      style={{ height: 70 }}
      loading={loading}
    />
  );
};

DashboardTotalSessionsSection.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool
};

export default DashboardTotalSessionsSection;
